import { render, staticRenderFns } from "./Rounds.vue?vue&type=template&id=6805d854"
import script from "./Rounds.vue?vue&type=script&lang=ts"
export * from "./Rounds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports